
/**
 * @roxi/routify 2.18.19
 * File generated Thu Oct 29 2026 09:38:15 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "2.18.19"
export const __timestamp = "2026-10-29T09:38:15.564Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes.js"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isDir": true,
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/account-health/index",
          "id": "_accountHealth_index",
          "component": () => import('../src/pages/account-health/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": true,
      "path": "/account-health",
      "id": "_accountHealth__layout",
      "component": () => import('../src/pages/account-health/_layout.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/admin/index",
          "id": "_admin_index",
          "component": () => import('../src/pages/admin/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": true,
      "path": "/admin",
      "id": "_admin__layout",
      "component": () => import('../src/pages/admin/_layout.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isIndex": true,
                  "isPage": true,
                  "path": "/group/:slug/edit/index",
                  "id": "_group__slug_edit_index",
                  "component": () => import('../src/pages/group/[slug]/edit/index.svelte').then(m => m.default)
                }
              ],
              "path": "/group/:slug/edit"
            }
          ],
          "path": "/group/:slug"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "path": "/group/create/index",
              "id": "_group_create_index",
              "component": () => import('../src/pages/group/create/index.svelte').then(m => m.default)
            }
          ],
          "path": "/group/create"
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/group/index",
          "id": "_group_index",
          "component": () => import('../src/pages/group/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": true,
      "path": "/group",
      "id": "_group__layout",
      "component": () => import('../src/pages/group/_layout.svelte').then(m => m.default)
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => import('../src/pages/index.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isIndex": true,
                  "isPage": true,
                  "path": "/meeting-room-manager/confirm-reservation/:slug/index",
                  "id": "_meetingRoomManager_confirmReservation__slug_index",
                  "component": () => import('../src/pages/meeting-room-manager/confirm-reservation/[slug]/index.svelte').then(m => m.default)
                }
              ],
              "path": "/meeting-room-manager/confirm-reservation/:slug"
            }
          ],
          "path": "/meeting-room-manager/confirm-reservation"
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/meeting-room-manager/index",
          "id": "_meetingRoomManager_index",
          "component": () => import('../src/pages/meeting-room-manager/index.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isDir": true,
                  "ext": "",
                  "children": [
                    {
                      "isIndex": true,
                      "isPage": true,
                      "path": "/meeting-room-manager/list-room/building/:slug/index",
                      "id": "_meetingRoomManager_listRoom_building__slug_index",
                      "component": () => import('../src/pages/meeting-room-manager/list-room/building/[slug]/index.svelte').then(m => m.default)
                    }
                  ],
                  "path": "/meeting-room-manager/list-room/building/:slug"
                }
              ],
              "path": "/meeting-room-manager/list-room/building"
            }
          ],
          "path": "/meeting-room-manager/list-room"
        }
      ],
      "path": "/meeting-room-manager"
    },
    {
      "isDir": true,
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isDir": true,
                  "ext": "",
                  "children": [
                    {
                      "isDir": true,
                      "ext": "",
                      "children": [
                        {
                          "isIndex": true,
                          "isPage": true,
                          "path": "/resource-management/:buildingId/resources/:resourceId/edit/index",
                          "id": "_resourceManagement__buildingId_resources__resourceId_edit_index",
                          "component": () => import('../src/pages/resource-management/[buildingId]/resources/[resourceId]/edit/index.svelte').then(m => m.default)
                        }
                      ],
                      "path": "/resource-management/:buildingId/resources/:resourceId/edit"
                    }
                  ],
                  "path": "/resource-management/:buildingId/resources/:resourceId"
                },
                {
                  "isDir": true,
                  "ext": "",
                  "children": [
                    {
                      "isIndex": true,
                      "isPage": true,
                      "path": "/resource-management/:buildingId/resources/create/index",
                      "id": "_resourceManagement__buildingId_resources_create_index",
                      "component": () => import('../src/pages/resource-management/[buildingId]/resources/create/index.svelte').then(m => m.default)
                    }
                  ],
                  "path": "/resource-management/:buildingId/resources/create"
                },
                {
                  "isIndex": true,
                  "isPage": true,
                  "path": "/resource-management/:buildingId/resources/index",
                  "id": "_resourceManagement__buildingId_resources_index",
                  "component": () => import('../src/pages/resource-management/[buildingId]/resources/index.svelte').then(m => m.default)
                }
              ],
              "path": "/resource-management/:buildingId/resources"
            }
          ],
          "path": "/resource-management/:buildingId"
        },
        {
          "isDir": true,
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isDir": true,
                  "ext": "",
                  "children": [
                    {
                      "isIndex": true,
                      "isPage": true,
                      "path": "/resource-management/building/:buildingId/edit/index",
                      "id": "_resourceManagement_building__buildingId_edit_index",
                      "component": () => import('../src/pages/resource-management/building/[buildingId]/edit/index.svelte').then(m => m.default)
                    }
                  ],
                  "path": "/resource-management/building/:buildingId/edit"
                }
              ],
              "path": "/resource-management/building/:buildingId"
            },
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isIndex": true,
                  "isPage": true,
                  "path": "/resource-management/building/create/index",
                  "id": "_resourceManagement_building_create_index",
                  "component": () => import('../src/pages/resource-management/building/create/index.svelte').then(m => m.default)
                }
              ],
              "path": "/resource-management/building/create"
            },
            {
              "isIndex": true,
              "isPage": true,
              "path": "/resource-management/building/index",
              "id": "_resourceManagement_building_index",
              "component": () => import('../src/pages/resource-management/building/index.svelte').then(m => m.default)
            }
          ],
          "isLayout": true,
          "path": "/resource-management/building",
          "id": "_resourceManagement_building__layout",
          "component": () => import('../src/pages/resource-management/building/_layout.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "path": "/resource-management/calendar-admin/index",
              "id": "_resourceManagement_calendarAdmin_index",
              "component": () => import('../src/pages/resource-management/calendar-admin/index.svelte').then(m => m.default)
            }
          ],
          "isLayout": true,
          "path": "/resource-management/calendar-admin",
          "id": "_resourceManagement_calendarAdmin__layout",
          "component": () => import('../src/pages/resource-management/calendar-admin/_layout.svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/resource-management/index",
          "id": "_resourceManagement_index",
          "component": () => import('../src/pages/resource-management/index.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "path": "/resource-management/site-data-extraction/index",
              "id": "_resourceManagement_siteDataExtraction_index",
              "component": () => import('../src/pages/resource-management/site-data-extraction/index.svelte').then(m => m.default)
            }
          ],
          "isLayout": true,
          "path": "/resource-management/site-data-extraction",
          "id": "_resourceManagement_siteDataExtraction__layout",
          "component": () => import('../src/pages/resource-management/site-data-extraction/_layout.svelte').then(m => m.default)
        }
      ],
      "isLayout": true,
      "path": "/resource-management",
      "id": "_resourceManagement__layout",
      "component": () => import('../src/pages/resource-management/_layout.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isIndex": true,
                  "isPage": true,
                  "path": "/service-account/:slug/edit/index",
                  "id": "_serviceAccount__slug_edit_index",
                  "component": () => import('../src/pages/service-account/[slug]/edit/index.svelte').then(m => m.default)
                }
              ],
              "path": "/service-account/:slug/edit"
            }
          ],
          "path": "/service-account/:slug"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "path": "/service-account/create/index",
              "id": "_serviceAccount_create_index",
              "component": () => import('../src/pages/service-account/create/index.svelte').then(m => m.default)
            }
          ],
          "path": "/service-account/create"
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/service-account/index",
          "id": "_serviceAccount_index",
          "component": () => import('../src/pages/service-account/index.svelte').then(m => m.default)
        }
      ],
      "path": "/service-account"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isIndex": true,
                  "isPage": true,
                  "path": "/shared-mailbox/:slug/edit/index",
                  "id": "_sharedMailbox__slug_edit_index",
                  "component": () => import('../src/pages/shared-mailbox/[slug]/edit/index.svelte').then(m => m.default)
                }
              ],
              "path": "/shared-mailbox/:slug/edit"
            }
          ],
          "path": "/shared-mailbox/:slug"
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isIndex": true,
              "isPage": true,
              "path": "/shared-mailbox/create/index",
              "id": "_sharedMailbox_create_index",
              "component": () => import('../src/pages/shared-mailbox/create/index.svelte').then(m => m.default)
            }
          ],
          "path": "/shared-mailbox/create"
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/shared-mailbox/index",
          "id": "_sharedMailbox_index",
          "component": () => import('../src/pages/shared-mailbox/index.svelte').then(m => m.default)
        }
      ],
      "path": "/shared-mailbox"
    }
  ],
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

